import { parse, toSeconds } from "iso8601-duration";

import { getJson, put } from "../helpers/request";

const HISTORY_URL = `${__AREENA_API}/v2/raw/profile/history`;
const BASE_PARAMETERS = {
  language: "fi",
  v: 10
};

const withHistoryOptions = (programId: string) => ({
  parameters: {
    ...BASE_PARAMETERS,
    ids: programId
  },
  url: HISTORY_URL,
  withCredentials: true
});

interface HistoryData {
  [programId: string]: {
    elapsed: string;
    finished: boolean;
    date: number;
  } | null;
}

export const getAreenaWatchedHistoryData = async (
  programId: string
): Promise<{
  watchedDuration?: number;
}> => {
  let history: HistoryData = {};
  try {
    history = await getJson<HistoryData>(withHistoryOptions(programId));
  } catch (e) {
    console.error("Failed to get history data", e);
  }

  const elapsed = history[programId]?.elapsed ?? "PT0S";
  return {
    watchedDuration: toSeconds(parse(elapsed))
  };
};

interface SaveHistoryProps {
  programId: string;
  time: number;
}

export const save = ({ programId, time }: SaveHistoryProps): void => {
  if (time !== 0) {
    put({
      body: { time },
      keepalive: true,
      parameters: {
        ...BASE_PARAMETERS
      },
      url: `${HISTORY_URL}/${encodeURIComponent(programId)}`,
      withCredentials: true
    }).catch(err => {
      console.error("Failed to save history", err);
    });
  }
};
